"use client"

import { DatabaseBackup, KeyIcon, SendToBack, Trash2 } from "lucide-react"
import { useState, useEffect } from "react"

function SettingsView() {
  const [privateMode, setPrivateMode] = useState(true)
  const [notifications, setNotifications] = useState(true)
  const [autoConnect, setAutoConnect] = useState(true)

  useEffect(() => {
    document.title = "Settings - KAXAA Wallet"
  }, [])

  return (
    <div className="settings-view">
      <div className="settings-section">
        <h2>Privacy Settings</h2>

        <div className="setting-item">
          <div className="setting-info">
            
            <div>
              <div className="setting-title">Private Mode</div>
              <div className="setting-description">Hide balances and transaction details</div>
            </div>
          </div>
          <label className="toggle-switch">
            <input type="checkbox" checked={privateMode} onChange={(e) => setPrivateMode(e.target.checked)} />
            <span className="toggle-slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div className="setting-info">
            
            <div>
              <div className="setting-title">Transaction Notifications</div>
              <div className="setting-description">Get notified about transaction status</div>
            </div>
          </div>
          <label className="toggle-switch">
            <input type="checkbox" checked={notifications} onChange={(e) => setNotifications(e.target.checked)} />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </div>

      <div className="settings-section">
        <h2>Network Settings</h2>

        <div className="setting-item">
          <div className="setting-info">
            
            <div>
              <div className="setting-title">Auto-connect to Relayers</div>
              <div className="setting-description">Automatically connect to available relayers</div>
            </div>
          </div>
          <label className="toggle-switch">
            <input type="checkbox" checked={autoConnect} onChange={(e) => setAutoConnect(e.target.checked)} />
            <span className="toggle-slider"></span>
          </label>
        </div>
      </div>

      <div className="settings-section">
        <h2>Security</h2>
        <div className="lg:p-0 p-3">
          <button className="settings-button"><KeyIcon /> Export Private Key</button>

          <button className="settings-button"><SendToBack /> Backup Wallet</button>

          <button className="settings-button danger"><Trash2 /> Delete Wallet</button>
        </div>
      </div>
    </div>
  )
}

export default SettingsView
